import { RelationWithStudentList } from "../../../../data/constant";

type RelationshipOption = { value: string; label: string };

export type CreateCoApplicantFieldsParams = {
  coApplicantNumbersValue: number;
  salutationList: RelationshipOption[];
  relationshipList?: RelationshipOption[];
  nationalityOptions?: RelationshipOption[];
  maritalStatusOptions?: RelationshipOption[];
  countryOfBirthOptions?: RelationshipOption[];
  cityOfBirthOptions?: RelationshipOption[];
};

export function createCoApplicantFields({
  coApplicantNumbersValue,
  salutationList,
  relationshipList = [],
  nationalityOptions = [],
  maritalStatusOptions = [],
  countryOfBirthOptions = [],
  cityOfBirthOptions = [],
}: CreateCoApplicantFieldsParams) {
  const salutationOptions: any = [...(salutationList || [])].map(
    (salutation: any) => salutation?.label
  );

  const relationshipOptions =
    (relationshipList?.length ?? 0) > 0
      ? relationshipList
      : RelationWithStudentList.map((label: string) => ({ value: label, label }));

  return [
    {
      label: `Relationship with Student`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}RelationWithStudent`,
      type: "autocomplete",
      required: true,
      options: { options: relationshipOptions },
    },
    {
      label: `Specify Relationship`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}OtherRelationWithStudent`,
      type: "text",
      required: false,
      options: null,
    },
    {
      label: `How should we address you? (Mr./Ms./etc.)`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}salutation`,
      type: "dropdown",
      required: true,
      options: { options: salutationOptions },
    },
    {
      label: `Co-Applicant First Name`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}FirstName`,
      type: "text",
      required: true,
    },
    {
      label: `Co-Applicant Last Name`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}LastName`,
      type: "text",
      required: true,
    },
    {
      label: `Gender`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}Gender`,
      type: "dropdown",
      options: { options: ["male", "female", "other", "prefer not to say"] },
      required: true,
    },
    {
      label: `Date of Birth`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}dob`,
      type: "date",
      required: true,
    },
    {
      label: "Nationality",
      name: `basicCoApplicant${coApplicantNumbersValue + 1}Nationality`,
      type: "autocomplete",
      required: true,
      options: { options: nationalityOptions },
    },
    {
      label: "Marital Status",
      name: `basicCoApplicant${coApplicantNumbersValue + 1}MaritalStatus`,
      type: "dropdown",
      required: true,
      options: { options: maritalStatusOptions },
    },
    {
      label: "Country of Birth",
      name: `basicCoApplicant${coApplicantNumbersValue + 1}CountryOfBirth`,
      type: "autocomplete",
      required: true,
      options: { options: countryOfBirthOptions },
    },
    {
      label: "City of Birth",
      name: `basicCoApplicant${coApplicantNumbersValue + 1}CityOfBirth`,
      type: "autocomplete",
      required: true,
      options: { options: cityOfBirthOptions },
    },
    {
      label: `PAN`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}PanNumber`,
      type: "text",
      required: true,
    },
    {
      label: `Co-Applicant's Mobile Number`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}PhoneNumber`,
      type: "phone",
      required: true,
    },
    {
      label: `Co-Applicant's Email ID`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}Email`,
      type: "email",
      required: true,
    },
    {
      label: `PAN Verified`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}IsPanVerified`,
      type: "boolean",
      required: false,
    },
    {
      label: `Mobile Verified`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}IsMobileVerified`,
      type: "boolean",
      required: false,
    },
    {
      label: `Email Verified`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}IsEmailVerified`,
      type: "boolean",
      required: false,
    },
    {
      label: `Do you want to consider income of the co-applicant for loan evaluation?`,
      name: `basicCoApplicant${coApplicantNumbersValue + 1}PayParty`,
      type: "radio",
      required: false,
      options: {
        options: [
            "Yes",
            "No"
        ]
      },
    },
    {
      label: "Are you employed?",
      name: `employmentCoApplicant${coApplicantNumbersValue + 1}isEmployed`,
      type: "radio",
      required: true,
      options: {
          options: [
              "Yes",
              "No"
          ]
      }
    },
    {
        label: "Employment Type",
        name: `employmentCoApplicant${coApplicantNumbersValue + 1}employmentType`,
        type: "dropdown",
        required: false,
        options: {
            options: [
                "FARMER",
                "Salaried",
                "SEP",
                "SENP",
                "Others"
            ]
        }
    }
  ];
}

